export default __webpack_public_path__ + "static/media/logo-itau.17ccbb7b.png";